import {
  GetCountryLookUpType,
  InvoiceListQueryParams,
  InvoicesListTypes,
} from '../../../../types/Invoicing/Invoices/InvoiceListTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, InvoicesListApiConfig } from '../../apiList'

const invoiceListType = async (
  queryParams: InvoiceListQueryParams,
): Promise<InvoicesListTypes> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: InvoicesListApiConfig.invoiceList,
    method: AllowedHttpMethods.get,
    params: queryParams,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getCountryList = async (): Promise<GetCountryLookUpType[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: InvoicesListApiConfig.getCountryLookup,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const exportInvoicesList = async (
  props: InvoiceListQueryParams,
): Promise<Blob> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: InvoicesListApiConfig.exportInvoicesList,
    method: AllowedHttpMethods.get,
    params: {
      projectType: props.projectType,
      status: props.status,
      fromDate: props.fromDate ?? '',
      toDate: props.toDate ?? '',
      multiText: props.multiText,
      invoiceDateSelection: props.invoiceDateSelection,
      country: props.country,
      intrnalOrNot: props.intrnalOrNot,
      token: localStorage.getItem('token') ?? '',
      invoiceType: props.invoiceType,
    },
    responseType: 'blob',
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const invoiceListApi = {
  invoiceListType,
  getCountryList,
  exportInvoicesList,
}

export default invoiceListApi
